// Accessible full-screen navigation for narrow viewports.
export default function menuOpen() {
    const menuButton = document.querySelector('.gh-burger');
    const header = document.querySelector('#gh-head');
    const menu = document.querySelector('#site-navigation');

    if (!menuButton || !header || !menu) {
        return;
    }

    const main = document.querySelector('.gh-main');
    const footer = document.querySelector('.gh-foot');
    const desktopQuery = window.matchMedia('(min-width: 1024px)');
    const menuButtonLabel = menuButton.querySelector('span');
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const getFocusableElements = () => [...header.querySelectorAll(focusableSelector)]
        .filter((element) => !element.hasAttribute('inert') && element.getClientRects().length > 0);

    const setMenuState = (isOpen, returnFocus = false) => {
        document.body.classList.toggle('gh-head-open', isOpen);
        menuButton.setAttribute('aria-expanded', String(isOpen));
        menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        if (menuButtonLabel) {
            menuButtonLabel.textContent = isOpen ? 'Close' : 'Menu';
        }
        main?.toggleAttribute('inert', isOpen);
        footer?.toggleAttribute('inert', isOpen);

        if (isOpen || returnFocus) {
            menuButton.focus();
        }
    };

    menuButton.addEventListener('click', () => {
        setMenuState(!document.body.classList.contains('gh-head-open'));
    });

    document.addEventListener('keydown', (event) => {
        if (!document.body.classList.contains('gh-head-open')) {
            return;
        }

        if (event.key === 'Escape') {
            setMenuState(false, true);
            return;
        }

        if (event.key === 'Tab') {
            const focusableElements = getFocusableElements();
            const firstElement = focusableElements[0];
            const lastElement = focusableElements.at(-1);

            if (!firstElement || !lastElement) {
                return;
            }

            if (event.shiftKey && document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            } else if (!event.shiftKey && document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    });

    menu.addEventListener('click', (event) => {
        if (event.target.closest('a')) {
            setMenuState(false);
        }
    });

    const syncForViewport = () => {
        if (desktopQuery.matches) {
            setMenuState(false);
        }
    };

    desktopQuery.addEventListener('change', syncForViewport);
    syncForViewport();
}
